<app-bread-crumb [items]="[{text:'servicos'}]" [sectionTitle]="'Lista de Todos Serviços'"></app-bread-crumb>

<section class="content">

  <div class="row">
    <div class="col-md-12">

      <ng-box [boxIcon]="'fa  fa-wrench'" [boxTitle]="'Serviços'">

        <!-- box header -->
        <ng-container class="ng-box-header">
          <ng-button 
          *ngIf="isAdmin()" 
          (click)="create()"
          [button]="{name:'novo servico', faIconClass:'fa fa-plus',color:'danger'}">
        </ng-button>
        </ng-container>

        

        <!-- box-content -->
        <ng-container class="ng-box-content">

          <ng-table [tableHeaderAndFooterColumns]="tableProprieties()" *ngIf="!isSpinnerLoading">


                <tr *ngFor="let service of objects" ngChangeColorOnHover>

                  <td>
                    <strong style="font-size: large;color:#f35309">{{service?.name}}</strong> <br>
                    <small>{{service?.description}}</small>
                  </td>

                  <td>
                    <!-- <span *ngIf="service.percentagems_id==1">{{service.khuzelaBonus | currency:'MZN':'symbol'}}</span> -->
                    <span>{{service?.khuzelaBonus }} {{service?.percentage?.name}} </span>
                  </td>

                  <td>
                    <!-- <span *ngIf="service.percentagems_id==1">{{service.clubBonus | currency:'MZN':'symbol'}}</span> -->
                    <span>{{service?.clubBonus }} {{service?.percentage?.name}}</span>
                  </td>

                  <td>
                    <!-- <span *ngIf="service.percentagems_id==1">{{service.partnerBonus | currency:'MZN':'symbol'}}</span> -->
                    <span>{{service?.partnerBonus }} {{service?.percentage?.name}}</span>
                  </td>

                  <td>
                    {{service?.partner?.name }}
                  </td>

                  <!-- controles -->
                  <ng-actions-table-bar>
                    <ng-button
                     *ngIf="isAdmin()" 
                      title="Editar"
                      (click)="edit(service)"
                      [button]="{faIconClass:'fa fa-edit',color:'danger'}"
                    ></ng-button>
                    <!-- <ng-button
                      title="Detalhe"
                      (click)="detail(service)"
                      [button]="{faIconClass:'fa fa-eye',color:'danger'}"
                    ></ng-button> -->
                    <ng-button
                    *ngIf="isAdmin()" 
                      title="Excluir"
                      (click)="delete(service)"
                      [button]="{faIconClass:'fa fa-close',color:'danger'}"
                    ></ng-button>
                  </ng-actions-table-bar>
                </tr>

            
          </ng-table>
          <!-- fim tabela -->
          <box-loading class="overlay" *ngIf="isSpinnerLoading"></box-loading>

        </ng-container>
        <!-- fim conteudo do box -->
      </ng-box>
      <!-- fim do box -->
    </div>
  </div>

</section>